<template>
  <div class="icon check" v-html="Check"></div>
</template>

<script>
import Check from './check.svg'
export default {
  data () {
    return {
      Check: Check
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/Check.vue